module.exports = __webpack_public_path__ + "assets/img/Affiches_009.898adbc9.jpg";